import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0),
    minWidth: 200,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

let CountrySelect = (props: any) => {
 
  const classes = useStyles();
  const values = [
    'United States',
    'Other'
  ];

  return (
    <FormControl margin = "dense" variant="outlined" className={classes.formControl}>
      <InputLabel htmlFor={props.name}>{props.label}</InputLabel>
      <Select
        native
        { ...props }
        inputProps={{
          name: props.name,
          id: props.id
        }}
      >
        <option aria-label="None" value="" />
        {values.map(v => {
          return <option key={v} value={v}>{v}</option>
        })}
      </Select>
    </FormControl>
  )
}

export default CountrySelect;